import(/* webpackMode: "eager" */ "/app/apps/web/app/[locale]/shadbala-calculator/page.tsx");
